let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4T2J3")).then(() => parcelRequire('emim1'));